/*
 * Background videos below the top of a page.
 *
 * A looping section video set to autoplay is downloaded with the page wherever it sits: six
 * megabytes on a phone for a tile three screens down. Sections that are not a page's first
 * render theirs without autoplay or preload and give them the class js-play-in-view; this
 * starts each one as it comes within a screen of the viewport. Until then its poster shows.
 */
(function () {
  'use strict';

  if (window.nbVideoInView) return;
  window.nbVideoInView = true;

  var SELECTOR = 'video.js-play-in-view';

  function start(video) {
    video.classList.remove('js-play-in-view');
    video.preload = 'auto';
    video.autoplay = true;

    var playing = video.play();
    if (playing && typeof playing.catch === 'function') playing.catch(function () {});
  }

  function watch(root) {
    var videos = Array.prototype.slice.call((root || document).querySelectorAll(SELECTOR));
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        start(entry.target);
      });
    }, { rootMargin: '100% 0px' });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); });
  } else {
    watch();
  }

  document.addEventListener('shopify:section:load', function (event) {
    watch(event.target);
  });
})();
